export type UndoOffer = { token: string; expiresAt: string; label: string };
export type UndoResult = { success: true; result?: unknown };

export function showUndo(undo?: UndoOffer | null, onUndone?: (result: UndoResult) => void) {
  if (!undo?.token || typeof window === 'undefined') return;
  window.dispatchEvent(new CustomEvent('nosivo:undo-offer', { detail: { ...undo, onUndone } }));
}

